import { render, staticRenderFns } from "./product-nav-row.vue?vue&type=template&id=f8a7cb54&scoped=true"
import script from "./product-nav-row.vue?vue&type=script&lang=js"
export * from "./product-nav-row.vue?vue&type=script&lang=js"
import style0 from "./product-nav-row.vue?vue&type=style&index=0&id=f8a7cb54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a7cb54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a7cb54')) {
      api.createRecord('f8a7cb54', component.options)
    } else {
      api.reload('f8a7cb54', component.options)
    }
    module.hot.accept("./product-nav-row.vue?vue&type=template&id=f8a7cb54&scoped=true", function () {
      api.rerender('f8a7cb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/product-nav-row.vue"
export default component.exports